import React, { Component } from 'react'

export default class Default extends Component {
    render() {
        return (
            <div style={{marginTop:"3rem",textAlign: "center", color: "red"}}>
            <h2>Page not found</h2>
        </div>
        )
    }
}


